if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        var bundleTemplate = this.getAttribute('suffix');
        //console.log(bundleTemplate,'bundleTemplate')
         
        this.form = this.querySelector('form');
        if(bundleTemplate == 'bundle-products-editable'){
         this.form.querySelector('[name=id]').disabled = true;
        }else{
          this.form.querySelector('[name=id]').disabled = false;
        } 
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();           
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
          if(this.classList.contains('build-box-form')){
            productVariantBundle(this,formData);
            return false;
          }
         
      
        if(this.querySelector('.ctm-card-product-sub')){
          let pHandle = this.querySelector('.ctm-card-product-sub').dataset.handle;
          let sValue = this.querySelector('.ctm-card-product-sub').value;
          // if(this.classList.contains('subscription-pro')){
          //   sValue = this.querySelectorAll('.ctm-card-product-sub option')[1].value;
          // }
          if(pHandle == 'august-basics-box'){
            sValue = this.querySelectorAll('.ctm-card-product-sub option')[1].value;
          }else if(pHandle == 'the-full-august-experience'){
            sValue = this.querySelectorAll('.ctm-card-product-sub option')[2].value;
          }
          formData.append('selling_plan',sValue);
        }
        if(this.classList.contains('build-box-form')){
          
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
       
        var sellingPlanIdSelector = document.querySelector('.skio-group-container.skio-group-container--available input[skio-selling-plan-group]:checked + label.skio-group-label select.skio-frequency');
        if(sellingPlanIdSelector){
          var productInfo = this.closest('product-info');
          if(productInfo){
            var sellingPlanId = sellingPlanIdSelector.value;
            //console.log(sellingPlanId,'sellingPlanId')
            formData.append('selling_plan',sellingPlanId);
          }  
        }
        
        let addData = [];

        this.querySelectorAll('.bundle-product input:checked').forEach(checkbox => {
            addData.push(checkbox.value);
        });
        
        let bundle_id = Math.floor(1000 + Math.random() * 9000 );
        
        if(addData.length > 0) {
            addData.forEach((id, index) => {
                let quantity = this.querySelector(`#quantity-${id}`).value; 
                let sellingPlanId = this.querySelector(`#selling-plan-${id}`).value;
                formData.append(`items[${index}][id]`, id);
                formData.append(`items[${index}][quantity]`, quantity);
                // formData.append(`items[${index}][properties][Bundle-id]`, bundle_id);
                // formData.append("properties[Type]", "Main");
                // formData.append("properties[Bundle-id]", bundle_id);
                formData.append(`items[${index}][selling_plan]`, sellingPlanId);
            });
        }else{
         
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
             // itg js
            if(document.querySelector('.show_quick')){
              document.querySelectorAll('.card_quick_variant').forEach(function(ele) {
                ele.classList.remove('show_quick');
              })
            }
            window.updateCartCount(response);
            // new
            
            if(this.dataset.setQty != 'false'){
             
              checkQty(response.id,this.dataset.setQty,false);
               //console.log(response.id,this.dataset.setQty,false,'setQty')
            }
            // itg js end
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}


async function checkQty(itemId,setQty,itsRemove){
  //console.log('pForm')
  if(document.querySelector('product-form[data-id="'+itemId+'"]')){
    let pForm = document.querySelector('product-form[data-id="'+itemId+'"]');
    
    if(itsRemove){
      pForm.querySelector('button[type="submit"]').removeAttribute('aria-disabled');
      pForm.querySelector('button[type="submit"]').removeAttribute('disabled');
      if(document.querySelector('.template-product')){
        pForm.querySelector('.pro-cart-text').innerHTML = 'add to cart';
      }else{
        pForm.querySelector('.pro-cart-text').innerHTML = 'Quick Add';
      }
    }else{
      let cartData = await getCart(); 
      let itemQuantity = 0;
      let inCart = false;
      for (let i = 0; i < cartData.items.length; i++) {
        let item = cartData.items[i];
        if(item.id == itemId){
          inCart = true;
          itemQuantity = itemQuantity + item.quantity;
        }
      }
      
      if(inCart){
        
        if(itemQuantity == setQty){
          pForm.querySelector('button[type="submit"]').setAttribute('aria-disabled',true);
          pForm.querySelector('button[type="submit"]').setAttribute('disabled',true);
          pForm.querySelector('.pro-cart-text').innerHTML = 'Already In Cart';
        }else{
          pForm.querySelector('button[type="submit"]').removeAttribute('aria-disabled');
          pForm.querySelector('button[type="submit"]').removeAttribute('disabled');
          if(document.querySelector('.template-product')){
            pForm.querySelector('.pro-cart-text').innerHTML = 'add to cart';
          }else{
            pForm.querySelector('.pro-cart-text').innerHTML = 'Quick Add';
          }
        }
      }
    }
  }
}



function productVariantBundle(productForm,formData) {
  let ele = document.querySelector('.product_custom_variant:checked');
    let itemQuantity = [];
    let itemId = [];
    let subId = [];
    let bundleItems = [];
    if (ele.value > 0) {
      let val = Number(ele.value);
      let getId = ele.dataset.getId;
      var pv = document.querySelector("#" + getId + ' option[value="' + val + '"]').dataset.pack;
      //console.log(pv,'pv')
      pv = pv.split("+");
      //console.log(pv,'split +')
      for (let i = 0; i < pv.length; i++) {
        let pT = pv[i].split("*");
       
        let pI = Number(ele.closest(".bbpa-pro-detail").querySelector('select.b-var option[value="' + pT[0] + '"]').dataset.id);
        //console.log(pI,'pI',pv[i],'split *')
        
        let pQ = Number(pT[1]);
        var subsSelector = document.querySelector('fieldset.skio-plan-picker')
        if(subsSelector) {
          let sI = Number(ele.closest(".bbpa-pro-detail").querySelector("select.b-sub").value);
          subId.push(sI);
        }
        itemQuantity.push(pQ);
        itemId.push(pI);
        
      }
      var subsSelector = document.querySelector('fieldset.skio-plan-picker')
      if(subsSelector) {
        var subsVal = document.querySelector('.product-tampon-tmpt-itg .skio-group-input:checked').value;
          //console.log(subsVal,'oneTimeSubs');
         if(subsVal){
          let subscriptionId = document.querySelector('.product-tampon-tmpt-itg .skio-group-content select.skio-frequency[skio-selling-plans="d1c31b7d875f371afdda85ee0906e6c15aee403a"]').value;
          //console.log(subscriptionId,'subscriptionId') 
          for (var i in itemId){
            let qty = itemQuantity[i] * formData.get('quantity');
            bundleItems.push({
              id: itemId[i],
              quantity: qty,
              selling_plan: subscriptionId,
            });
          }       
         }else{
           for (var i in itemId){
            let qty = itemQuantity[i] * formData.get('quantity');
            bundleItems.push({
              id: itemId[i],
              quantity: qty,
            });
          }
         } 
      }else{
           for (var i in itemId){
            let qty = itemQuantity[i] * formData.get('quantity');
            
            bundleItems.push({
              id: itemId[i],
              quantity: qty,
            });
          }
         }  
    }
    let addItems = {
      items: bundleItems,
      sections: productForm.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    };
      fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(addItems),
    })
    .then((response) => response.json())
    .then((data) => {
      window.updateCart(data);
      //console.log(pI,'pII')
      // productForm.cart.renderContents(data);
    }).finally(() => {
      productForm.submitButton.classList.remove('loading');
      if (productForm.cart && productForm.cart.classList.contains('is-empty')) productForm.cart.classList.remove('is-empty');
      if (!productForm.error) productForm.submitButton.removeAttribute('aria-disabled');
      productForm.querySelector('.loading__spinner').classList.add('hidden');
    }); 
}